import { axiosGet } from '.';

export const getDownloadUrl = () => axiosGet('/zhibo/package/getDownloadUrl');

export const getVideoUrl = () => axiosGet('/zhibo/systemConfig/selectById?systemConfigId=1430002327835723638');
